import _ from 'lodash';

export const getValueWithEmpty = (value: number | undefined): string => {
  if (value === undefined) return '';

  return value.toString() || '';
};

export const parseInputNumber = (value: string): number | undefined => {
  const num = _.toNumber(value);

  return value === '' || !_.isFinite(num) ? undefined : num;
};
